import { buildAccess, canEditTraining as canEditTrainingWith } from './access-levels';
import { can as canWith } from './access-permissions';

/**
 * The signed-in member's access (see access-levels.js), set by Root once the
 * user is known.
 *
 * Held here rather than passed as a prop because the route guards and filter
 * wrappers each re-clone their child with a fixed subset of props, so a new
 * prop would have to be threaded through every one of them to reach a page.
 * It only changes on sign-in and sign-out, both of which re-render Root.
 */
// Signed out (or before GetStatus answers): no permissions, so everything is refused.
let current = buildAccess({}, {});

export function setCurrentAccess(access) {
    current = access || buildAccess({}, {});
}

export function getCurrentAccess() {
    return current;
}

/** Whether the signed-in member's level gives `key` at least `atLeast` ('yes' for a toggle). */
export function can(key, atLeast) {
    return canWith(current.permissions, current.permissionValues, key, atLeast);
}

/** Whether the signed-in member edits the training module `topSlug` (training.edit; Brokerage Continuum is its own case). */
export function canEditTraining(topSlug) {
    return canEditTrainingWith(current, topSlug);
}
